import { render, staticRenderFns } from "./DashTree.vue?vue&type=template&id=09142811&scoped=true"
import script from "./DashTree.vue?vue&type=script&lang=ts"
export * from "./DashTree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09142811",
  null
  
)

export default component.exports